// extracted by mini-css-extract-plugin
export default {"row":"createTask_row__0Nrpl","col":"createTask_col__lDsV6","card":"createTask_card__K79t0"};